"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _fade_in = _interopRequireDefault(require("./fade_in"));
var _fade_out = _interopRequireDefault(require("./fade_out"));
var _constants = require("../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FADE_STATES = {
  FADING_IN: 'FADING_IN',
  FADE_IN_COMPLETE: 'FADE_IN_COMPLETE',
  FADING_OUT: 'FADING_OUT',
  FADE_OUT_COMPLETE: 'FADE_OUT_COMPLETE'
};
var TimedFade = function TimedFade(props) {
  var showMilliseconds = props.showMilliseconds,
    children = props.children;
  var _React$useState = React.useState(FADE_STATES.FADING_IN),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    fadeState = _React$useState2[0],
    setFadeState = _React$useState2[1];
  var shouldRender = fadeState !== FADE_STATES.FADE_OUT_COMPLETE;
  React.useEffect(function () {
    if (fadeState !== FADE_STATES.FADE_IN_COMPLETE) {
      return;
    }
    var timer = setTimeout(function () {
      setFadeState(FADE_STATES.FADING_OUT);
    }, showMilliseconds);
    return function () {
      return clearTimeout(timer);
    };
  }, [fadeState, showMilliseconds]);
  var onAnimationEnd = function onAnimationEnd() {
    if (fadeState === FADE_STATES.FADING_IN) {
      setFadeState(FADE_STATES.FADE_IN_COMPLETE);
    } else if (fadeState === FADE_STATES.FADING_OUT) {
      setFadeState(FADE_STATES.FADE_OUT_COMPLETE);
    }
  };
  var Animation = fadeState === FADE_STATES.FADING_OUT ? _fade_out["default"] : _fade_in["default"];
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Animation, (0, _extends2["default"])({}, (0, _constants.getDataProvidesProps)(_objectSpread({
    'data-provides': 'timed-fade-animation'
  }, props)), {
    onAnimationEnd: onAnimationEnd
  }), children);
};
var _default = exports["default"] = TimedFade;